import { render, staticRenderFns } from "./Recipient.vue?vue&type=template&id=5324bfd4&lang=pug&"
import script from "./Recipient.vue?vue&type=script&lang=js&"
export * from "./Recipient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports